import React, { useState } from "react"
import PropTypes from "prop-types";

import LineItemRow from "views/picking/order/components/LineItemRow";
import ShipmentHeader from "./ShipmentHeader";

import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import {LineItemStatus} from "../../../../../../utils/LineItemStatus";
import {ShippingMethods} from "utils/ShippingMethods";

export default function ShipmentTable({shipment, incrementalNumber, currentOrganization}) {

    const [displayShipmentCheckbox, setDisplayShipmentCheckbox] = useState(false);

    const isClickAndCollect = shipment.shipmentData.shippingMethod.type === ShippingMethods.CLICK_COLLECT
        || shipment.shipmentData.shippingMethod.type === ShippingMethods.DRIVE
        || shipment.shipmentData.shippingMethod.type === ShippingMethods.LOCKER;

    const isSecondStepClickAndCollect = isClickAndCollect && shipment.shipmentData.trackingNumber;

    return (
        <>
            <TableRow>
                <TableCell
                    colSpan={9}
                    sx={{ padding: 0 }}
                >
                    <ShipmentHeader
                        incrementalNumber={incrementalNumber}
                        shipment={shipment.shipmentData}
                        lineItems={shipment.lineItems}
                        currentOrganization={currentOrganization}
                        displayShipmentCheckbox={displayShipmentCheckbox}
                        setDisplayShipmentCheckbox={setDisplayShipmentCheckbox}
                    />
                </TableCell>
            </TableRow>
            {shipment.lineItems
                .sort((a, b) => {
                    if (a.status === LineItemStatus.CANCELED) return 1;
                    if (b.status === LineItemStatus.CANCELED) return -1;
                    if (a.status === LineItemStatus.UNAVAILABLE) return 1;
                    if (b.status === LineItemStatus.UNAVAILABLE) return -1;
                    return 0;
                })
                .map((lineItem, index) => {
                    return <LineItemRow
                        lineItem={lineItem}
                        shipment={shipment}
                        displayShipmentCheckbox={isSecondStepClickAndCollect ? false : displayShipmentCheckbox}
                        key={index}
                    />
                })}
        </>
    )
}

ShipmentTable.propTypes = {
    shipment: PropTypes.object.isRequired
};
